import appInsights from '../AppInsights';

export default ({ getState }) => next => action => {
    if (loggedActions[action.type]) {
        const ev = loggedActions[action.type]({ state: getState(), payload: action.payload })
        appInsights.trackEvent(ev)
    }
    return next(action);
}

const loggedActions = {
    'IS_LOADED': ({ state }) => ({
        name: 'cargaInicial',
        properties: {
            file: state.selection.file
        }
    }),
    'FETCH_DATA': ({state, payload}) => ({
        name: 'btnConsultar',
        properties:{
            action: state.metadata.matrix,
            variableName: payload.stub.find(item => item.code === "Indicator" || "Indicador").label
        }
    }),
    'FETCH_DATA_CHART': () => ({
        name: 'btnGraficar'
    }),
    'SET_QUERY_ALL_VALUES': ({ state, payload }) => ({
        name: 'checkSelecionaTodoVar',
        properties: {
            variableName: payload,
            file: state.selection.file
        }
    }),
    'GET_PXQ': ({ payload }) => ({
        name: 'cargaPXQ',
        properties: {
            pxq: payload
        }
    }),
    'STUB_RIGTH': ({ payload }) => ({
        name: 'pivoteoStubDer',
        properties: {
            action: 'stubToHeading',
            values: payload
        }
    }),
    'HEAD_LEFT': ({ payload }) => ({
        name: 'pivoteoHeadIzq',
        properties: {
            action: 'headingToStub',
            values: payload
        }
    }),
    'STUB_UP': ({ payload }) => ({
        name: 'pivoteoStubArriba',
        properties: {
            action: 'stubUp',
            values: payload
        }
    }),
    'STUB_DOWN': ({ payload }) => ({
        name: 'pivoteoStubAbajo',
        properties: {
            action: 'stubUp',
            values: payload
        }
    }),
    'HEAD_UP': ({ payload }) => ({
        name: 'pivoteoHeadArriba',
        properties: {
            action: 'headingUp',
            values: payload
        }
    }),
    'HEADING_DOWN': ({ payload }) => ({
        name: 'pivoteoHeadAbajo',
        properties: {
            action: 'headingDown',
            values: payload
        }
    })

}